var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-8 -8 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4907 2.22266C7.37661 2.22266 3.23529 6.6031 3.23529 12.0004C3.23529 17.3978 7.37661 21.7782 12.4907 21.7782C17.6141 21.7782 21.7647 17.3978 21.7647 12.0004C21.7647 6.6031 17.6141 2.22266 12.4907 2.22266ZM12.5 19.8227C8.405 19.8227 5.08823 16.3222 5.08823 12.0004C5.08823 7.67866 8.405 4.17821 12.5 4.17821C16.595 4.17821 19.9118 7.67866 19.9118 12.0004C19.9118 16.3222 16.595 19.8227 12.5 19.8227ZM15.7426 11.0227C16.5116 11.0227 17.1323 10.3675 17.1323 9.55599C17.1323 8.74443 16.5116 8.08932 15.7426 8.08932C14.9737 8.08932 14.3529 8.74443 14.3529 9.55599C14.3529 10.3675 14.9737 11.0227 15.7426 11.0227ZM9.25735 11.0227C10.0263 11.0227 10.6471 10.3675 10.6471 9.55599C10.6471 8.74443 10.0263 8.08932 9.25735 8.08932C8.48838 8.08932 7.86764 8.74443 7.86764 9.55599C7.86764 10.3675 8.48838 11.0227 9.25735 11.0227ZM12.5 17.3782C14.6587 17.3782 16.4931 15.9507 17.2343 13.956L7.76573 13.956C8.50691 15.9507 10.3413 17.3782 12.5 17.3782Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.0002,
    height: 21.9998,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/Emoji3.f0c6b0ea6b91127f9f0228e4c20e092d.svg";
export { ForwardRef as ReactComponent };